import { FormField } from "generated/graphql";
import { useAppSelector } from "redux/hooks";
import {
  deleteField,
  selectLensEditorForm,
  selectLensEditorLensId,
  selectLensFormSections,
  selectProfileBuilderSectionlessFields,
} from "redux/slices/lensEditor";
import { Card } from "@mui/material";
import { P } from "theme/typography";
import { nonEmpty } from "../../../helpers/coll";
import Fields from "./Fields";
import Sections from "./Sections";
import useAppDispatchWithSnackbar from "../../../helpers/hooks/useAppDispatchWithSnackbar";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LensUpdateSnackbarContext } from "contexts/LensUpdateSnackbarContext";

const ProfileBuilderSections = () => {
  const form = useAppSelector(selectLensEditorForm);
  // Move to ID, so the state gets refreshed automatically
  const snackpatch = useAppDispatchWithSnackbar();
  const sectionlessFields = useAppSelector(selectProfileBuilderSectionlessFields);
  const formSections = useAppSelector(selectLensFormSections);
  const lensId = useAppSelector(selectLensEditorLensId);
  const { enqueueLensUpdateTimerSnackbar } = useContext(LensUpdateSnackbarContext);

  const navigate = useNavigate();

  const { sectionId } = useParamNumbers(["sectionId"]);
  const handleFieldClick = (field: FormField) => {
    navigate(`fields/${field.id}`);
  };
  const handleDeleteField = (fieldId: number) => {
    snackpatch(deleteField({ fieldId }), {
      successMessage: "Field deleted",
      errorMessage: "Unable to delete Field",
    }).then(() => enqueueLensUpdateTimerSnackbar(lensId));
  };

  return (
    <Card sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      {nonEmpty(formSections) && (
        <>
          <Sections
            formId={form.id}
            handleFieldClick={handleFieldClick}
            handleDeleteField={handleDeleteField}
            sections={formSections}
            sectionId={sectionId}
          />
          {sectionlessFields.length > 0 && (
            <>
              <P variant="h5">Fields not in a section (please fix)</P>
              <Fields
                fields={sectionlessFields}
                handleFieldClick={handleFieldClick}
                handleDeleteField={handleDeleteField}
              />
            </>
          )}
        </>
      )}
    </Card>
  );
};

export default ProfileBuilderSections;
